function Header() {
    return (
      <header className="header">
        <h2>🏋️ FitZone Pro</h2>
        <nav>
          <a href="#services">Services</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact">Book</a>
        </nav>
      </header>
    );
  }
  
  export default Header;